module.exports = __webpack_public_path__ + "static/media/light.af72e517.png";